import React, { useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ThemeTableDetail from 'components/ThemeTableDetail';

function ThemeTable(props) {
  const {
    literals, setBreadcrumb, match: { params: { id, section } },
    resetAll, narratives,
  } = props;

  const paramId = parseInt(id, 10);
  let callId = 0;
  if (narratives) {
    narratives.forEach((elem) => {
      if (elem.theme_tables.includes(paramId)) {
        callId = elem.id;
      }
    });
  }

  // Breadcrumb
  useEffect(() => {
    const breadcrumb = [
      {
        type: 'back',
      },
      {
        color: '#ffffff',
        text: literals.themeTable,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetAll();
  }, [paramId]);

  return (<ThemeTableDetail id={paramId} callId={callId} initSection={section} showBackButton />);
}

ThemeTable.propTypes = {
  literals: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetAll: PropTypes.func.isRequired,
};

export default ThemeTable;



// WEBPACK FOOTER //
// ./src/routes/ThemeTable/components/index.jsx